<template>
	<div id="app">
		<Header title="Idée de dessin" />
		<div class="mainContent">
			<div class="container">
				<div class="content">
					<div class="row">
						<div class="col">
							<Jubotron />
						</div>
					</div>
					<div class="row">
						<div class="col">
							<div class="wrapCenter">
								<button @click="handleRandom">Abracadabra !</button>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col">
							<!-- {{debug}} -->
							<div class="result" id="result">
								<a
									:href="'https://www.google.fr/search?hl=fr&tbm=isch&source=hp&q=' + choice1"
									target="_blank"
									class="result1"
								>{{ choice1 }}</a>
								<span class="middleResult">et</span>
								<a
									:href="'https://www.google.fr/search?hl=fr&tbm=isch&source=hp&q=' + choice2"
									target="_blank"
									class="result2"
								>{{ choice2 }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer>@ 2021 Stéphane Savona</footer>
	</div>
</template>

<script>
import Header from "./components/Header.vue";
import Jubotron from "./components/Jubotron.vue";
import db from "./assets/firebase";

export default {
	name: "app",
	components: {
		Header,
		Jubotron
	},
	data() {
		return {
			choice1: null,
			choice2: null,
			temp1: null,
			temp2: null
		};
	},
	methods: {
		startRandom() {
			db.ref("animals").on("value", el => {
				this.temp1 = el.val()[
					Math.floor(Math.random() * el.val().length)
				];
				this.temp2 = el.val()[
					Math.floor(Math.random() * el.val().length)
				];
				while (this.temp1 == this.temp2) {
					this.temp2 = el.val()[
						Math.floor(Math.random() * el.val().length)
					];
				}
				this.choice1 = this.temp1;
				this.choice2 = this.temp2;
				document.querySelector(".middleResult").style.display = "block";
				document.querySelector(".result1").style.display = "block";
				document.querySelector(".result2").style.display = "block";
			});
		},
		handleRandom() {
			this.startRandom();
		}
	}
};
</script>
